module.exports = __webpack_public_path__ + "img/tg_02 (4).892bc257.jpg";